/**
 * 名前正規化ユーティリティ
 * 犬名や登録番号の正規化・比較に使用
 */

/**
 * カタカナをひらがなに変換
 */
function katakanaToHiragana(str: string): string {
  return str.replace(/[\u30A1-\u30F6]/g, (char) =>
    String.fromCharCode(char.charCodeAt(0) - 0x60)
  );
}

/**
 * 全角英数字を半角に変換
 */
function fullWidthToHalfWidth(str: string): string {
  return str.replace(/[Ａ-Ｚａ-ｚ０-９]/g, (char) =>
    String.fromCharCode(char.charCodeAt(0) - 0xfee0)
  );
}

/**
 * 全角スペースと半角スペースを除去
 */
function removeSpaces(str: string): string {
  return str.replace(/[\s\u3000]/g, '');
}

/**
 * 犬名の正規化
 * - カタカナ → ひらがな変換
 * - 全角 → 半角変換
 * - スペース除去
 * - 小文字化
 */
export function normalizeDogName(name: string): string {
  if (!name) return '';

  let normalized = name;
  normalized = fullWidthToHalfWidth(normalized);
  normalized = katakanaToHiragana(normalized);
  normalized = removeSpaces(normalized);
  normalized = normalized.toLowerCase();

  return normalized;
}

/**
 * 登録番号の正規化
 * - ハイフン・スペース除去
 * - 全角 → 半角変換
 * - 大文字化
 */
export function normalizeRegistrationNumber(num: string): string {
  if (!num) return '';

  let normalized = num;
  normalized = fullWidthToHalfWidth(normalized);
  normalized = removeSpaces(normalized);
  normalized = normalized.replace(/-/g, '');
  normalized = normalized.toUpperCase();

  return normalized;
}

/**
 * 2つの文字列の類似度を計算（レーベンシュタイン距離ベース）
 * @returns 0-100 のパーセンテージ
 */
export function calculateStringSimilarity(str1: string, str2: string): number {
  if (str1 === str2) return 100;
  if (!str1 || !str2) {
    if (!str1 && !str2) return 100;
    return 0;
  }

  const len1 = str1.length;
  const len2 = str2.length;
  const maxLen = Math.max(len1, len2);

  // レーベンシュタイン距離を計算
  const dp: number[][] = Array(len1 + 1)
    .fill(null)
    .map(() => Array(len2 + 1).fill(0));

  for (let i = 0; i <= len1; i++) dp[i][0] = i;
  for (let j = 0; j <= len2; j++) dp[0][j] = j;

  for (let i = 1; i <= len1; i++) {
    for (let j = 1; j <= len2; j++) {
      const cost = str1[i - 1] === str2[j - 1] ? 0 : 1;
      dp[i][j] = Math.min(
        dp[i - 1][j] + 1, // deletion
        dp[i][j - 1] + 1, // insertion
        dp[i - 1][j - 1] + cost // substitution
      );
    }
  }

  const distance = dp[len1][len2];
  const similarity = ((maxLen - distance) / maxLen) * 100;

  return Math.round(similarity);
}
